import React from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import { STRING } from 'resources'
import { APP_URLS } from 'resources/urls'
import formatPoints from 'utils/format-points'
import profileInfoSelectors from 'models/ProfileInfo/selectors'

import ProfilePictureWithScribble from 'components/ProfilePictureWithScribble'

import {
  ProfilePictureWrapper,
  ProfileBalance,
  ProfileContainer,
  ProfileContent,
  ProfileUserLabel,
  ProfileWrapper,
} from './styles'
import AccountStatusPill from './AccountStatusPill'

const NavMenuProfileAndBalance = ({ closeMobileNavMenu = null }) => {
  const balance = useSelector(profileInfoSelectors.getBalance)
  const userHandle = useSelector(profileInfoSelectors.getUserHandle)
  const profilePictureUrl = useSelector(profileInfoSelectors.getProfilePictureUrl)
  const isVerifiedUser = useSelector(profileInfoSelectors.getIsVerifiedUser)
  const isVip = useSelector(profileInfoSelectors.getIsVip)

  let accountStatus = 'basic'
  if (isVip) {
    accountStatus = 'vip'
  } else if (isVerifiedUser) {
    accountStatus = 'trusted'
  }

  return (
    <ProfileWrapper>
      <ProfileContainer>
        <ProfilePictureWrapper onClick={closeMobileNavMenu}>
          <ProfilePictureWithScribble profilePictureUrl={profilePictureUrl} size={50} isVip={isVip} />
        </ProfilePictureWrapper>
        <ProfileContent>
          {userHandle ? (
            <ProfileUserLabel onClick={closeMobileNavMenu}>{userHandle}</ProfileUserLabel>
          ) : (
            <ProfileUserLabel to={APP_URLS.WALLET} onClick={closeMobileNavMenu}>
              {STRING.navMenu.balanceLabel}
            </ProfileUserLabel>
          )}
          <ProfileBalance to={APP_URLS.WALLET} onClick={closeMobileNavMenu}>
            {formatPoints(balance, false, true)}
          </ProfileBalance>
        </ProfileContent>
      </ProfileContainer>
      <AccountStatusPill status={accountStatus} />
    </ProfileWrapper>
  )
}

NavMenuProfileAndBalance.propTypes = {
  closeMobileNavMenu: PropTypes.func,
}

export default NavMenuProfileAndBalance
